<app-shared-dialog
  [title]="dialogTitle"
  [options]="dialogOptions"
  (cancel)="close()">
  <div class="user-form-dialog__body">
    <div class="user-form-dialog__row">
      <div class="user-form-dialog__field">
        <ui-form-field
          [formControl]="fullNameControl"
          [placeholder]="'user.full_name' | translate"
          [errorMessages]="{ required: 'validation.required' | translate }">
        </ui-form-field>
      </div>

      <div class="user-form-dialog__field">
        <ui-form-field
          [formControl]="emailControl"
          [placeholder]="'common.email' | translate"
          [errorMessages]="{ required: 'validation.required' | translate, invalidEmail: 'validation.invalid_email' | translate }">
        </ui-form-field>
      </div>
    </div>

    <div class="user-form-dialog__field">
      <ui-form-field
        type="select"
        [formControl]="roleControl"
        [placeholder]="'user.roles' | translate"
        [options]="roleOptions"
        [errorMessages]="{ required: 'validation.required' | translate }">
      </ui-form-field>
    </div>
  </div>

  <div customConfirm>
    <ui-button
      type="primary"
      [label]="saveLabel | uppercase"
      [icon]="saveIcon"
      iconPosition="start"
      [isLoading]="isSubmitting"
      [disabled]="isFormInvalid || isSubmitting"
      (click)="submitForm()">
    </ui-button>
  </div>
</app-shared-dialog>
